export const SUPPORT_MAIN_ROUTE = 'help';
export const SUPPORT_TERMS_AND_CONTITIONS = 'terms-and-conditions';
